<template>
  <div class="row comp-search-result my-2 selected-column">
    <div class="col-12 grid-row">
      <div class="grid-name">
        {{ externalForm.text }}
      </div>
      <a class="action-icon remove-icon" tabindex="0" @click="$emit('remove')">
        <font-awesome-icon icon="times" aria-hidden="true" class="removeIcon" />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'SelectedExternalForm',
  props: {
    externalForm: {
      type: Object as () => { id: number; text: string },
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.removeIcon {
  float: right;
  margin-top: 18px;
  width: 22px;
  height: 22px;

  &:hover {
    cursor: pointer;
  }
}
.remove-icon {
  grid-column: 2;
  -ms-grid-column: 2;
  line-height: 60px;
}
.selected-column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  margin-right: 3px !important;
  margin-left: 3px !important;
  max-width: 40%;
}
.comp-search-result {
  background: $brand-white;
  cursor: context-menu;
  border: 1px solid $brand-grey4;

  .grid-row {
    display: grid;
    display: -ms-grid;
    grid-template-rows: 60px;
    -ms-grid-rows: 60px;
    grid-template-columns: 1fr auto;
  }

  .grid-name {
    width: 100%;
    grid-column: 1;
    -ms-grid-column: 1;
    line-height: 60px;

    font-size: 13px;
    letter-spacing: 0.3px;
    font-weight: 700;
    color: $brand-red;
    text-transform: uppercase;
    font-family: 'Signa-Light', Sans-Serif;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    user-select: none;
    -webkit-user-select: none; /* For Safari */
    -ms-user-select: none; /* For old IE/Edge */
  }

  @media (max-width: $media-md-max) {
    .grid-row {
      display: flex;
    }
  }
}
@media (max-width: $media-sm-max) {
  .selected-column {
    max-width: 100% !important;
  }
}
</style>
